var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loggedIn)?_c('router-link',{staticClass:"mt-4",attrs:{"to":"/","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
return [_c('v-btn',{attrs:{"href":href,"color":"black","text":""},on:{"click":navigate}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Startseite ")],1)]}}],null,false,1226420758)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }